export default "__VITE_ASSET__5bYNSd2L__"